<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '~ds/lib/utils'

import type { TextHighlightVariants } from '.'

import { textHighlightVariants } from '.'

// Literal booleans, not TextHighlightVariants['...']: the SFC compiler cannot
// resolve the VariantProps<> generic to Boolean, so bare attributes would reach
// cva as '' (falsy) in fresh builds. Literal Boolean props default to false when
// absent, so the recipe's true-defaults must be restated here via withDefaults.
const props = withDefaults(defineProps<{
  color?: TextHighlightVariants['color'];
  blur?: boolean;
  rounded?: boolean;
  class?: HTMLAttributes['class'];
}>(), {
  color: undefined,
  blur: true,
  rounded: true,
  class: undefined,
})
</script>

<template>
  <mark
    data-slot="text-highlight"
    :class="cn('relative isolate inline-block bg-transparent leading-[1.6] text-foreground', props.class)"
  >
    <!-- Blurred colour bar: a transparent-text copy of the phrase, behind the
         crisp text, so the marker edge is a real gaussian blur while the text
         stays sharp. Wraps identically (same width/font/leading, no h-padding). -->
    <span aria-hidden="true" class="pointer-events-none absolute inset-0 -z-10 select-none">
      <span :class="textHighlightVariants({ color, blur, rounded })"><slot /></span>
    </span>
    <slot />
  </mark>
</template>
